export default __webpack_public_path__ + "static/media/np.61f060b3.jpg";